// Hands a file the user attached in the AI chatbot off to the page that owns
// the matching import modal (Employee Costs' Smart Import wizard, or Time
// Activity's Employee Direct Allocation wizard). The chatbot lives outside
// those pages, so a File (non-serializable, can't go through Redux) is
// stashed here and a DOM event wakes up whichever page is mounted; a
// same-tick "already pending" check covers the case where the target page
// mounts fresh via navigation after the event has already fired.

export type ChatImportKind = 'smart' | 'directAllocation';

export const CHAT_IMPORT_EVENT = 'cap:chat-import-request';

interface PendingChatImport {
	kind: ChatImportKind;
	file: File;
}

let pending: PendingChatImport | null = null;

export function requestChatImport(kind: ChatImportKind, file: File) {
	pending = { kind, file };
	window.dispatchEvent(new CustomEvent(CHAT_IMPORT_EVENT));
}

export function consumeChatImport(kind: ChatImportKind): File | null {
	if (pending && pending.kind === kind) {
		const { file } = pending;
		pending = null;
		return file;
	}
	return null;
}
